import styled, { css } from 'styled-components';
import { Stack } from '@mui/material';
import { flex } from './Flex';

export const flexSpace = css`
  ${flex};
  justify-content: space-between;
  align-items: center;
`;

export const FlexSpace = styled(Stack).attrs({ direction: 'row' })`
  ${flexSpace};
`;
